export default "__VITE_ASSET__9f760a38__"